import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  Menu,
  Typography,
  MenuItem,
  Grid,
  Stack,
  Alert,
  Snackbar,
  DialogActions,
  TextField,
  DialogContent,
  Dialog,
  FormControl,
  DialogTitle,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import axios from "axios";
import { baseUrl } from "../../Utils/serviceRequest";
import { Close, Done } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { deleteAsset } from "../../DatabaseServices/InventoryServices/RegisteredAssetsService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function ViewData({
  data,
  showAction,
  loading,
  fetchData,
  assetType,
  brand,
  classification,
  loc,
  status,
}) {
  // const [assetType, setAssetTypeName] = useState([]);
  // const [brand, setBrandName] = useState([]);
  // const [classification, setClassification] = useState([]);

  if (Array.isArray(brand) && brand.length > 0) {
    var brandList = [];
    brand.forEach((element) => {
      brandList.push(element.brandName);
    });
  }
  if (Array.isArray(classification) && classification.length > 0) {
    var classificationList = [];
    classification.forEach((element) => {
      classificationList.push(element.classificationName);
    });
  }
  if (Array.isArray(assetType) && assetType.length > 0) {
    var assetTypeList = [];
    assetType.forEach((element) => {
      assetTypeList.push(element.assetTypeName);
    });
  }

  // const [loc, setLoc] = useState([]);
  // const [status, setStatus] = useState([]);
  const ram = ["8GB", "16GB", "24GB", "32GB"];
  const storage = ["256GB", "500GB", "512GB", "1TB", "2TB"];
  const processor = [
    "i5",
    "i7",
    "i9",
    "m1",
    "m2",
    "m3",
    "m4",
    "m5",
    "AMD Ryzen 5",
    "AMD Ryzen 7",
    "AMD Ryzen 9",
  ];
  const gen = [
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
    "13th",
    "Ultra",
  ];
  // const mac=["M1 chip","M2 chip"]

  const CustomDetailPanel = ({ row }) => {
    // console.log("prop received form customDetailPanel", row);

    const formattedDate = (timeStamp) => {
      const date = new Date(parseInt(timeStamp));
      //console.log(date, "date");
      const formattedDate = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      // console.log(formattedDate, "formattedDate");
      return formattedDate;
    };

    const detials = [
      { label: "Asset Type", value: row.original.assetTypeName || "-" },
      { label: "Asset Id", value: row.original.assetId || "-" },
      { label: "Asset Sl No.", value: row.original.assetSlNo || "-" },
      { label: "Brand", value: row.original.brand || "-" },
      { label: "Comments", value: row.original.comments || "-" },
      { label: "Assigned To", value: row.original.employeeName || "-" },
      { label: "State", value: row.original.state || "-" },
      { label: "Base Location", value: row.original.baseLocation || "-" },
      { label: "Assign Location", value: row.original.location || "-" },
      { label: "Return Location", value: row.original.returnLocation || "-" },
      { label: "User Location", value: row.original.userLocation || "-" },
      { label: "Generation", value: row.original.gen || "-" },
      { label: "Model", value: row.original.model || "-" },
      // { label: "OS", value: row.original.os || "-" },
      { label: "Processor", value: row.original.processor || "-" },
      { label: "RAM", value: row.original.ram || "-" },
      { label: "Storage", value: row.original.storage || "-" },
      {
        label: "Procure Date",
        value: row.original.procureDate
          ? formattedDate(row.original.procureDate)
          : "-",
      },
      {
        label: "Assign Date",
        value: row.original.assetStDate
          ? formattedDate(row.original.assetStDate)
          : "-",
      },
      {
        label: "Return Date",
        value: row.original.assetEndDate
          ? formattedDate(row.original.assetEndDate)
          : "-",
      },
      {
        label: "Warranty End Date",
        value: row.original.warrantyEndDate
          ? formattedDate(row.original.warrantyEndDate)
          : "-",
      },
    ];

    return (
      <Grid
        sx={{ bgcolor: "#F1F5FE", width: "100%" }}
        container
        spacing={1}
        alignItems="center"
        justifyContent="flex-start"
      >
        {detials.map((field, index) => {
          return (
            <Grid item xs={2} key={index}>
              <Stack>
                <Typography variant="h6" align="center">
                  {field.label}
                </Typography>
                <Typography variant="body1" align="center">
                  {field.value}
                </Typography>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const inputSize = {
    style: {
      height: "5vh",
      maxHeight: "32px",
      width: "100%",
      maxWidth: "100%",
      // padding: "2px 10px",
    },
    MenuProps: {
      PaperProps: {
        style: {
          maxHeight: 300, // Set your preferred max height
          overflowY: "auto", // Enable vertical scrolling
        },
      },
    },
  };
  // for assign date update
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [SuccessStatus, setSuccessStatus] = useState(false);
  const [FailedStatus, setFailedStatus] = useState(false);
  const [FailedMessage, setFailedMessage] = useState("Failed!!");
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("success");
  //loading state
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useSelector((state) => state.userReducer.userData);
  //for assign date updatioin
  const handleOpenDatePicker = (row) => {
    setSelectedRow(row);
    setSelectedDate(
      row.assetStDate ? new Date(parseInt(row.assetStDate)) : null,
    );
    setOpenDateDialog(true);
  };

  const handleSaveDate = async () => {
    const timestamp = new Date(selectedDate).getTime(); // Get Unix timestamp
    const date = new Date(timestamp); // Create Date object from timestamp
    // const formattedDate = `${date.getFullYear()}-${
    //   date.getMonth() + 1
    // }-${date.getDate()}`;

    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const data = {
      assetId: selectedRow?.assetId,
      assignDate: formattedDate,
      performedBy: currentUser.employeeId,
    };
    setIsLoading(true);

    try {
      const response = await axios.patch(
        `${baseUrl}/update-assigned-date`,
        data,
      );
      // if (response) {
      //   handleClose();

      // }
      // debugger;
      if (response.status) {
        setIsLoading(false);
        setSuccessStatus(true);
        fetchData();
        // setSnackBarMessage(response.data.message);
        // setSnackBarSeverity("success");
        // setSnackBarStatus(true);
        // handleClose();
        setOpenDateDialog(false);
      }
      if (!response.status) {
        // setFailedStatus(true);
        setIsLoading(false);
        setSnackBarMessage(response.data.message);
        setSnackBarSeverity("error");
        setSnackBarStatus(true);
        setOpenDateDialog(false);
        // handleClose();
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      // handleClose();
      setFailedStatus(true);
    }
  };
  // Custom cell component for actions
  const CustomActionCell = (props) => {
    // console.log("Props received by CustomActionCell:", props);
    const cell = props.cell.row.original;

    const currentUser = useSelector((state) => state.userReducer.userData);

    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModalStatus, setDeleteModalStatus] = useState(false);
    const [SelectedAssets, setSelectedAssets] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenuItem, setActiveMenuItem] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [updateForm, setUpdateForm] = useState({
      assetId: "",
      assetSlNo: "",
      assetType: "",
      model: "",
      baseLocation: "",
      location: "",
      comments: "",
      status: "",
      // statusID:"",
      ram: "",
      storage: "",
      gen: "",
      processor: "",
    });

    let handleClose = (e) => {
      setDeleteModalStatus(false);
      setUpdateModal(false);
      setShowMenu(false);
      setSelectedStatus("");
      setActiveMenuItem("");

      setUpdateForm({
        assetId: "",
        assetSlNo: "",
        assetType: "",
        model: "",
        baseLocation: "",
        location: "",
        comments: "",
        // statusId:"",
        status: "",
        ram: "",
        storage: "",
        gen: "",
        processor: "",
      });
      //setImportStatus(false);
    };

    const handleDeleteMuiGrid = async () => {
      // debugger;
      try {
        let response = await deleteAsset(SelectedAssets);
        console.dir(response);
        if (response.status === 200) {
          await fetchData();
          setDeleteModalStatus(false);
          setSelectedAssets([]);
          setSuccessStatus(true);
        }
        if (response.status !== 200) {
          setSelectedAssets([]);
          setDeleteModalStatus(false);
          setFailedStatus(true);
        }
      } catch (error) {
        setSelectedAssets([]);
        setDeleteModalStatus(false);
        setFailedStatus(true);
      }
    };

    const updateSerialNo = async () => {
      setIsLoading(true);
      try {
        const response = await axios.patch(`${baseUrl}/update-serial-number`, {
          serialNumber: updateForm.assetSlNo,
          assetId: updateForm.assetId,
          // comments: updateForm.comments,
          performedBy: currentUser.employeeId,
        });
        if (response.data.status) {
          setSuccessStatus(true);
          setIsLoading(false);
          await fetchData();
          // setSnackBarMessage(response.data.message);
          // setSnackBarSeverity("success");
          // setSnackBarStatus(true);
          handleClose();
        }
        if (response.data.status === false) {
          // setFailedStatus(true);
          setIsLoading(false);
          setSnackBarMessage(response.data.message);
          setSnackBarSeverity("error");
          setSnackBarStatus(true);
          handleClose();
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        handleClose();
        setFailedStatus(true);
      }
    };

    const updateConfiguration = async () => {
      console.log("inside the function", updateForm);
      setIsLoading(true);
      try {
        const response = await axios.put(
          `${baseUrl}/updateAssetConfiguration`,
          {
            // assetSlNo: updateForm.assetSlNo,
            assetId: updateForm.assetId,
            gen: updateForm.gen,
            processor: updateForm.processor,
            ram: updateForm.ram,
            storage: updateForm.storage,
            comments: updateForm.comments,
            performedBy: currentUser.employeeId,
          },
        );
        if (response.data.result === "success") {
          setIsLoading(false);
          setSuccessStatus(true);
          await fetchData();
          // setSnackBarMessage(response.data.message);
          // setSnackBarSeverity("success");
          // setSnackBarStatus(true);
          handleClose();
        }
        if (response.data.result === "error") {
          // setFailedStatus(true);
          setIsLoading(false);
          setSnackBarMessage(response.data.message);
          setSnackBarSeverity("error");
          setSnackBarStatus(true);
          handleClose();
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        handleClose();
        setFailedStatus(true);
      }
    };

    const updateLocationStatus = async (value) => {
      console.log("called location");
      console.log(updateForm);
      const data = {
        performedBy: currentUser.employeeId,
      };
      setIsLoading(true);
      try {
        const response = await axios.put(
          `${baseUrl}/updateAssetStatusAndBaseLocation?assetId=${updateForm.assetId}&statusId=${selectedStatus}&baseLocation=${updateForm.location}&query=${value}&userComments=${updateForm.comments}`,
          data,
        );
        // if (response) {
        //   handleClose();

        // }
        // debugger;
        if (response.data.result === "success") {
          setIsLoading(false);
          setSuccessStatus(true);
          await fetchData();
          // setSnackBarMessage(response.data.message);
          // setSnackBarSeverity("success");
          // setSnackBarStatus(true);
          handleClose();
        }
        if (response.data.result === "error") {
          // setFailedStatus(true);
          setSnackBarMessage(response.data.message);
          setIsLoading(false);
          setSnackBarSeverity("error");
          setSnackBarStatus(true);
          handleClose();
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        handleClose();
        setFailedStatus(true);
      }
    };

    const handleUpdateOnChange = (e) => {
      // debugger;
      let value = e.target.value;
      let name = e.target.name;
      const selectedStatus = status.find(
        (option) => option.statusName === value,
      );
      const statusId = selectedStatus ? selectedStatus.statusId : null;
      let stateData = { ...updateForm };
      if (name === "status") {
        stateData[name] = value;
        setSelectedStatus(statusId);
      } else {
        stateData[name] = value;
      }
      setUpdateForm(stateData);
      // console.log("971", updateForm);
    };

    // const [rowData, setRowData]= useState({})

    const handleMenuOpen = (event) => {
      // setRowData(rowData)
      setShowMenu(true);
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setShowMenu(false);
    };

    let ShowUpdateModal = (menuItem) => {
      console.log("rowData", cell);
      let func = () => {
        setUpdateForm({ ...updateForm, ...cell });
        setActiveMenuItem(menuItem);
        setUpdateModal(true);
        // setSelectedStatus(updateForm.status)
      };
      func();
      console.log("23", activeMenuItem, menuItem, updateForm);
    };

    // useEffect(() => {
    //   console.log("12", updateForm?.location);
    //   console.log("12", loc);
    //   // console.log("123",updateForm.status)
    //   // // setSelectedStatus(updateForm.status)
    //   // console.log("1",selectedStatus)
    // }, [updateForm]);

    const handleDeleteClick = () => {
      console.log("rowData", cell);

      console.log("Delete clicked for", cell.assetId);
      setDeleteModalStatus(true);
      setSelectedAssets([cell.assetId]);

      // Handle delete action for the selected row
    };

    //update validation

    const handleUpdateValidations = (val) => {
      // debugger
      if (val === 1) {
        console.log("updateForm data", updateForm);
        if (updateForm.baseLocation === null) {
          setFailedStatus(true);
          setFailedMessage(" Location cannot be empty");
          // alert("Base Location cannot be empty");
        } else updateLocationStatus("locationUpdate");
      } else if (val === 2) {
        console.log("updateForm data 2", updateForm);
        if (updateForm.status === null || updateForm.status === "") {
          setFailedStatus(true);
          setFailedMessage("Status cannot be empty");
          // alert("Status cannot be empty");
        } else updateLocationStatus("statusUpdate");
      } else if (val === 3) {
        console.log("updateForm data 3", updateForm);
        // if (updateForm.assetSlNo === null || updateForm.assetSlNo === "") {
        //   setFailedStatus(true);
        //   setFailedMessage("Asset Serial Number cannot be empty");
        // } else
        if (updateForm.ram === null || updateForm.ram === "") {
          setFailedStatus(true);
          setFailedMessage("RAM cannot be empty");
        } else if (updateForm.storage === null || updateForm.storage === "") {
          setFailedStatus(true);
          setFailedMessage("Storage cannot be empty");
        } else if (updateForm.gen === null || updateForm.gen === "") {
          setFailedStatus(true);
          setFailedMessage("Generation cannot be empty");
        } else if (
          updateForm.processor === null ||
          updateForm.processor === ""
        ) {
          setFailedStatus(true);
          setFailedMessage("Processor cannot be empty");
        } else {
          updateConfiguration();
        }
      } else if (val === 4) {
        console.log("updateForm data 4", updateForm);
        if (updateForm.assetSlNo === null || updateForm.assetSlNo === "") {
          setFailedStatus(true);
          setFailedMessage("Asset serial number cannot be empty");
        } else {
          updateSerialNo();
        }
      }
    };

    const updateComments = async () => {
      if (!updateForm.comments || updateForm.comments.trim() === "") {
        setFailedStatus(true);
        setFailedMessage("Comments cannot be empty");
        return;
      }

      setIsLoading(true);

      try {
        const response = await axios.patch(`${baseUrl}/update-comment`, {
          assetId: updateForm.assetId,
          comment: updateForm.comments,
          performedBy: currentUser.employeeId,
        });

        if (response.data.status) {
          setIsLoading(false);
          setSuccessStatus(true);
          await fetchData();
          setSnackBarMessage(response.data.message);
          setSnackBarSeverity("success");
          setSnackBarStatus(true);
          handleClose();
        } else {
          setIsLoading(false);
          setSnackBarMessage(
            response.data.message || "Failed to update comments",
          );
          setSnackBarSeverity("error");
          setSnackBarStatus(true);
          handleClose();
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        handleClose();
        setFailedStatus(true);
        setFailedMessage("Failed to update comments");
      }
    };

    if (SuccessStatus | FailedStatus) {
      setTimeout(() => {
        setFailedStatus(false);
        setSuccessStatus(false);
      }, 3000);
    }

    useEffect(() => {
      if (activeMenuItem === "updateStatus") {
        const selectedStatus = status.find(
          (option) => option.statusName === updateForm.status,
        );
        const statusId = selectedStatus ? selectedStatus.statusId : null;
        setSelectedStatus(statusId);
      }
    }, [activeMenuItem]);

    return (
      <>
        <Box>
          <Button onClick={handleMenuOpen}>
            <MoreVertIcon />
          </Button>
          <Menu anchorEl={anchorEl} open={showMenu} onClose={handleMenuClose}>
            <MenuItem
              onClick={() => {
                ShowUpdateModal("updateLocation");
              }}
              selected={activeMenuItem === "updateLocation"}
              disabled={cell.isAssigned === true}
            >
              Update Location
            </MenuItem>

            <MenuItem
              onClick={() => {
                ShowUpdateModal("updateStatus");
              }}
              selected={activeMenuItem === "updateStatus"}
              disabled={cell?.status?.toLowerCase() === "assigned"}
            >
              Update Status
            </MenuItem>

            {cell.assetTypeName === "Monitor" ? (
              <MenuItem
                onClick={() => {
                  ShowUpdateModal("updateSerialNo");
                }}
                selected={activeMenuItem === "updateSerialNo"}
              >
                Update Serial No.
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  ShowUpdateModal("updateConfiguration");
                }}
                selected={activeMenuItem === "updateConfiguration"}
                disabled={cell.assetTypeName !== "Laptop" && true}
              >
                Update Configuration
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                ShowUpdateModal("updateComments");
              }}
              selected={activeMenuItem === "updateComments"}
            >
              Update Comments
            </MenuItem>

            {/* <MenuItem
              onClick={() => {
                ShowUpdateModal("updateConfiguration");
              }}
              selected={activeMenuItem === "updateConfiguration"}
              disabled={cell.assetTypeName !== "Laptop" && true}
            >
              Update Configuration
            </MenuItem> */}

            <MenuItem
              onClick={handleDeleteClick}
              selected={activeMenuItem === "Delete"}
            >
              Delete
            </MenuItem>
            {/* <MenuItem onClick={ShowEditModalFuncNew}>Edit</MenuItem>
            <MenuItem onClick={handleDeleteClick}>Delete</MenuItem> */}
          </Menu>
        </Box>

        {/* 1327 */}

        {/* modal update */}

        <Dialog open={updateModal} sx={{}} fullWidth maxWidth="md">
          <DialogContent sx={{ padding: "25px" }} className="wbScroll">
            <Stack
              sx={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                spacing={2}
                rowSpacing={3}
                // justifyContent={"center"}
                alignItems={"center"}
              >
                {/* location drop down */}

                {activeMenuItem === "updateLocation" && (
                  <>
                    <Grid item xs={6} sx={{ maxWidth: "100%" }}>
                      <Typography sx={{ color: "#424242", width: "100%" }}>
                        Assign Location<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <FormControl sx={{ width: "100%" }} fullWidth>
                        <TextField
                          select
                          fullWidth
                          // disabled={false}
                          disabled={activeMenuItem === "updateStatus"}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="location"
                          value={updateForm?.location}
                          onChange={handleUpdateOnChange}
                        >
                          {loc.map((option) => {
                            return (
                              <MenuItem key={option.label} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Comments
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="comments"
                          value={updateForm.comments}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        ></TextField>
                      </FormControl>
                    </Grid>
                  </>
                )}
                {activeMenuItem === "updateStatus" && (
                  <>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Status <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          select
                          disabled={activeMenuItem === "updateLocation"}
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="status"
                          value={updateForm.status}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {status
                            .filter(
                              (item) =>
                                item.isActive === true && item.statusId !== 1,
                            )
                            .map((option) => {
                              return (
                                <MenuItem
                                  key={option.statusId}
                                  value={option.statusName}
                                >
                                  {option.statusName}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Comments
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="comments"
                          value={updateForm.comments}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        ></TextField>
                      </FormControl>
                    </Grid>
                  </>
                )}
                {activeMenuItem === "updateSerialNo" && (
                  <>
                    <Grid item xs={12}>
                      <Typography sx={{ color: "#424242" }}>
                        Asset Serial No <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // select
                          // disabled={activeMenuItem === "updateLocation"}
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="assetSlNo"
                          value={updateForm.assetSlNo}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {/* {status
                            .filter(
                              (item) =>
                                item.isActive === true && item.statusId !== 1,
                            )
                            .map((option) => {
                              return (
                                <MenuItem
                                  key={option.statusId}
                                  value={option.statusName}
                                >
                                  {option.statusName}
                                </MenuItem>
                              );
                            })} */}
                        </TextField>
                      </FormControl>
                    </Grid>
                    {/* <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Comments
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="comments"
                          value={updateForm.comments}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        ></TextField>
                      </FormControl>
                    </Grid> */}
                  </>
                )}

                {activeMenuItem === "updateConfiguration" && (
                  <>
                    {/* <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Asset Serial No<span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="assetSlNo"
                          value={updateForm.assetSlNo}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        ></TextField>
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        RAM <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          select
                          // disabled={activeMenuItem === "updateLocation"}
                          // disabled={false}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="ram"
                          value={updateForm.ram}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {ram.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Storage <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          select
                          // disabled={activeMenuItem === "updateLocation"}
                          //  disabled={false}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="storage"
                          value={updateForm.storage}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {storage.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Generation <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          select
                          // disabled={activeMenuItem === "updateLocation"}
                          //  disabled={false}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="gen"
                          value={updateForm.gen}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {gen.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Processor <span style={{ color: "red" }}>*</span>
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          select
                          // disabled={activeMenuItem === "updateLocation"}
                          //  disabled={false}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          SelectProps={inputSize}
                          // InputProps={inputSize}

                          id="outlined-basic"
                          variant="outlined"
                          name="processor"
                          value={updateForm.processor}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        >
                          {processor.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ color: "#424242" }}>
                        Comments
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <TextField
                          // disabled={true}
                          // sx={{ width: "100%", }}
                          margin="normal"
                          // SelectProps={inputSize}
                          InputProps={inputSize}
                          id="outlined-basic"
                          variant="outlined"
                          name="comments"
                          value={updateForm.comments}
                          //  value={selectedStatus}
                          onChange={handleUpdateOnChange}
                        ></TextField>
                      </FormControl>
                    </Grid>
                  </>
                )}
                {activeMenuItem === "updateComments" && (
                  <Grid item xs={12}>
                    <Typography sx={{ color: "#424242" }}>
                      Update Comments <span style={{ color: "red" }}>*</span>
                    </Typography>

                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        margin="normal"
                        variant="outlined"
                        name="comments"
                        value={updateForm.comments || ""}
                        onChange={handleUpdateOnChange}
                        placeholder="Enter updated comments"
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                if (activeMenuItem === "updateLocation")
                  handleUpdateValidations(1);
                else if (activeMenuItem === "updateStatus")
                  handleUpdateValidations(2);
                else if (activeMenuItem === "updateConfiguration")
                  handleUpdateValidations(3);
                else if (activeMenuItem === "updateSerialNo")
                  handleUpdateValidations(4);
                else if (activeMenuItem === "updateComments") updateComments();
              }}
              variant="contained"
              sx={{
                backgroundColor: "#0288d1",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#140B96",
                  boxShadow: "1px #000000",
                },
              }}
              disableRipple
            >
              Save
            </Button>
            <Button
              onClick={handleClose}
              variant="contained"
              sx={{
                backgroundColor: "#E0E0E0",
                textTransform: "none",
                color: "black",
                "&:hover": {
                  backgroundColor: "#E0E0E0",
                  boxShadow: "1px #000000",
                },
              }}
              disableRipple
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* *modal DELETE***  */}

        <Dialog open={deleteModalStatus}>
          <DialogTitle sx={{ textAlign: "center" }}>
            <ErrorOutlineIcon sx={{ color: "#FF9A22", fontSize: "2.3rem" }} />
            <Typography variant="h6">Are you sure?</Typography>
            <Typography sx={{ fontSize: "0.9rem" }}>
              <span>Are you sure you want to delete this record?</span>
              <br />
              <span>This process cannot be undone.</span>
            </Typography>
          </DialogTitle>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => handleDeleteMuiGrid()}
              variant="contained"
              sx={{
                backgroundColor: "#CF0100",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#B70100",
                  boxShadow: "1px #000000",
                },
              }}
              disableRipple
            >
              Delete
            </Button>
            <Button
              onClick={() => {
                if (SelectedAssets.length === 1) {
                  setSelectedAssets([]);
                }
                setDeleteModalStatus(false);
              }}
              variant="contained"
              sx={{
                backgroundColor: "#E0E0E0",
                textTransform: "none",
                color: "black",
                "&:hover": {
                  backgroundColor: "#E0E0E0",
                  boxShadow: "1px #000000",
                },
              }}
              disableRipple
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* end */}
      </>
    );
  };

  const initialState = {
    sorting: [
      {
        id: "assetId", //sort by age by default on page load
        desc: false,
      },
    ],
    density: "compact", // Set default density to compact
    // enableDensityToggle: false, // Disable density toggle
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "assetId",
        header: "Asset ID",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      // {
      //   accessorKey: "brand",
      //   header: "Brand",
      //   size: 100,
      // },
      {
        accessorKey: "assetSlNo",
        header: "Asset Serial No",
        size: 180,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "assetTypeName",
        header: "Asset Type",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        filterVariant: "multi-select",
        filterSelectOptions: assetTypeList,
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "classificationName",
        header: "Classification",
        size: 150,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        filterVariant: "multi-select",
        filterSelectOptions: classificationList,
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "brand",
        header: "Brand",
        size: 150,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        filterVariant: "multi-select",
        filterSelectOptions: brandList,
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "location",
        header: "Location",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },

      {
        accessorKey: "isAssigned",
        header: "Assigned",
        size: 120,
        // Cell: ({ value }) => <span>{value ? "✔" : "❌"}</span>, // Custom cell rendering for the isActive column
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          // console.log("value of isActive", cell.row.original.isActive);
          const value = cell.row.original.isAssigned;
          return (
            <span>
              {value ? (
                <Done sx={{ color: "green" }} />
              ) : (
                <Close sx={{ color: "red" }} />
              )}
            </span>
          );
        }, // Custom cell rendering for the isActive column
      },
      {
        accessorKey: "status",
        header: "Current Status",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,

                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "assetStDate",
        header: "Assign Date",
        size: 100,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          if (cell.row.original.assetStDate === null) {
            return "-";
          } else {
            const date = new Date(parseInt(cell.row.original.assetStDate));
            const formattedDate = `${date.getDate()}/${
              date.getMonth() + 1
            }/${date.getFullYear()}`;
            // return formattedDate;
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span>{formattedDate}</span>

                <IconButton
                  size="small"
                  onClick={() => handleOpenDatePicker(cell.row.original)}
                >
                  <CalendarMonthIcon fontSize="small" />
                </IconButton>
              </div>
            );
          }
        },
      },
      {
        accessorKey: "assetEndDate",
        header: "Return Date",
        size: 100,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          if (cell.row.original.assetEndDate === null) {
            return "-";
          } else {
            const date = new Date(parseInt(cell.row.original.assetEndDate));
            const formattedDate = `${date.getDate()}/${
              date.getMonth() + 1
            }/${date.getFullYear()}`;
            return formattedDate;
          }
        },
      },
      {
        accessorKey: "employeeName",
        header: "Assigned To",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "userStatus",
        header: "Employee Status",
        size: 120,
        Header: ({ column }) => (
          <span style={{ whiteSpace: "normal" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ cell }) => {
          return (
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                whiteSpace: "normal",
              }}
            >
              {cell.getValue()}
            </span>
          );
        },
      },
      showAction
        ? {
            accessorKey: "action",
            header: "Action",
            sortable: false,
            filterable: false,
            enableColumnActions: false,

            size: 120,
            // Cell: ({ cell }) =>
            //   status.length > 0 ? <CustomActionCell cell={cell} /> : null,

            Cell: ({ cell }) => <CustomActionCell cell={cell} />,
          }
        : undefined,
    ],
    [showAction, status, loc],
  );

  const table = useMaterialReactTable({
    data,
    columns: columns.filter(Boolean),
    // expandedRows,
    renderDetailPanel: CustomDetailPanel,
    state: { showSkeletons: loading },
    initialState: initialState,
    defaultColumn: { minSize: 20, maxSize: 400, size: 80 },
    muiTableHeadCellProps: {
      sx: {
        padding: "10px",
        background: "#F1F5FE",
        // whiteSpace:"normal"
      },
    },
    muiTableProps: {
      sx: {
        tableLayout: "fixed",
        // width: '100%'
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor:
          !row.getIsExpanded() &&
          (row.original.status === "not returned" ||
            row.original.status === "NOT RETURNED")
            ? "#f8d2b9"
            : "inherit",
      },
    }),
    enableDensityToggle: false,
    enableStickyHeader: true,
  });

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MaterialReactTable table={table} />
      {/* assign date model */}
      <Dialog open={openDateDialog} onClose={() => setOpenDateDialog(false)}>
        <DialogTitle>Change Assign Date</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
              //      minDate={
              //   userSelected?.joiningDate
              //     ? new Date(userSelected.joiningDate)
              //     : null
              // }
              minDate={new Date(selectedRow?.joiningDate)}
              maxDate={new Date()}
              renderInput={(params) => (
                <FormControl sx={{ width: "100%" }}>
                  <TextField {...params} />
                </FormControl>
              )}
            />
          </LocalizationProvider>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDateDialog(false)}>Cancel</Button>

          <Button variant="contained" onClick={handleSaveDate}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/***** SNACKBAR COMPONENT * */}
      {ReactDOM.createPortal(
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={SuccessStatus}
          autoHideDuration={3000}
          onClose={() => setSuccessStatus(false)}
        >
          <Alert severity="success" sx={{ width: "100%" }}>
            SUCCESS!!
          </Alert>
        </Snackbar>,
        document.body,
      )}
      {ReactDOM.createPortal(
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={FailedStatus}
          autoHideDuration={3000}
          onClose={() => setFailedStatus(false)}
        >
          <Alert elevation={6} severity="error" sx={{ width: "100%" }}>
            {FailedMessage}
          </Alert>
        </Snackbar>,
        document.body,
      )}
      {ReactDOM.createPortal(
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          // sx={{ marginTop: "60px", zIndex: 99999 }}
          open={snackBarStatus}
          autoHideDuration={4000}
          onClose={() => setSnackBarStatus(false)}
        >
          <Alert
            onClose={() => setSnackBarStatus(false)}
            severity={snackBarSeverity}
            sx={{ width: "100%" }}
          >
            {snackBarMessage}
          </Alert>
        </Snackbar>,
        document.body,
      )}

      {/* *******************  */}
    </>
  );
}
